import { MoneyV2 } from '../sdk';

export const getDiscountPercentage = (
  price: MoneyV2,
  compareAtPrice?: MoneyV2,
) => {
  const parsedPrice = parseFloat(price.amount);
  const parsedCompareAtPrice = parseFloat(compareAtPrice?.amount);
  if (!parsedCompareAtPrice || !parsedPrice) return 0;
  if (parsedCompareAtPrice <= parsedPrice) return 0;
  return Math.ceil(
    ((parsedCompareAtPrice - parsedPrice) / parsedCompareAtPrice) * 100,
  );
};
